<table class="table table-hover table-striped fixed-layout" fixedHeader>
  <thead>
  <tr>
    <th>{{ 'projectVersionHistoryPopup.datagrid.header.project_version' | translate }}
      <app-project-version-history-dropdown-menu [historyVersion]="projectHistoryVersions()" [(selectedFilter)]="selectedFilter"/>
      <i [class]="getVersionIcon()" (click)="changeOrderToProjectVersion()"></i>
    </th>
    <th>{{ 'projectVersionHistoryPopup.datagrid.header.user' | translate }}</th>
    <th>{{ 'projectVersionHistoryPopup.datagrid.header.remark' | translate }}</th>
    <th>{{ 'projectVersionHistoryPopup.datagrid.header.date' | translate }}
      <i [class]="getDateIcon()" (click)="changeOrderToDate()"></i>
    </th>
    <th>{{ 'projectVersionHistoryPopup.datagrid.header.status' | translate }}</th>
  </tr>
  </thead>
</table>

<div class="container-custom-list">
  <ng-scrollbar [visibility]="'hover'" [style.max-height.px]="500">
    <table class="table table-hover table-striped fixed-layout table-wrap">
      <tbody>
        @for (historyEntry of (tableEntries() | orderBy:orderAttribute:sortAsc); track historyEntry.key) {
          <tr [class.active]="historyEntry.key === selectedEntry()?.key" [attr.data-testid]="'version-entry-' + historyEntry.projectVersionLabel">
            <td (click)="setEntry(historyEntry)">{{ historyEntry.projectVersionLabel }}</td>
            <td (click)="setEntry(historyEntry)">{{ historyEntry.username }}</td>
            <td (click)="setEntry(historyEntry)">{{ historyEntry.remark | translate }}</td>
            <td (click)="setEntry(historyEntry)">{{ historyEntry.dateLabel }}</td>
            <td class="bg-transparent" (click)="setEntry(historyEntry)">
              <div class="d-flex">
                  <span tooltip
                        [tooltipText]="historyEntry.finalizationStateTooltip">
                    <app-svg-icon [type]="historyEntry.finalizationStateIcon"/>
                  </span>
                <div class="flex-grow-1"></div>
                @if (isPriceCalculationAvailable(historyEntry)) {
                  <a
                    tooltip
                    (click)="!showPriceCalculationLink || openPriceCalculationLookup(historyEntry)"
                    [tooltipText]="'projectVersionHistoryPopup.loadPriceCalculation.button' | translate">
                    <app-svg-icon type="calculator"/>
                  </a>
                }
                @if (!versionLoadedByTemporaryLink() && !isConstruction) {
                  <a
                    (click)="copyProjectUrl(historyEntry)"
                    tooltip
                    [tooltipText]="'projectVersionHistoryPopup.datagrid.tooltip.project_link' | translate"
                    [attr.data-testid]="'share-version-link-' + historyEntry.projectVersionLabel">
                    <app-svg-icon type="share"/>
                  </a>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </ng-scrollbar>
</div>
